module.exports = __webpack_public_path__ + "img/微详情示例图.399b17bf.jpeg";